export const integrationData = {
	tabelaAR: [
		{ codigo: "00", descricao: "SEM AR" },
		{ codigo: "05", descricao: "TRIO EASY CLEAN" },
		{ codigo: "07", descricao: "MULTIKOT" },
		{ codigo: "26", descricao: "OPTIFOG HMC PREMIUM" },
		{ codigo: "27", descricao: "CRIZAL FORTE UV" },
		{ codigo: "28", descricao: "CRIZAL FORTE UV FI" },
		{ codigo: "34", descricao: "CRIZAL EASY UV" },
		{ codigo: "37", descricao: "CRIZAL PREVENCIA" },
		{ codigo: "39", descricao: "NO REFLEX" },
		{ codigo: "43", descricao: "INVISIBLE" },
		{ codigo: "45", descricao: "ELEMENT" },
		{ codigo: "46", descricao: "GLACIER" },
		{ codigo: "47", descricao: "GLACIER PLUS" },
		{ codigo: "48", descricao: "NCC" },
		{ codigo: "49", descricao: "NCC FI" },
		{ codigo: "53", descricao: "STAND AR" },
		{ codigo: "65", descricao: "CRIZAL SAPPHIRE FI" },
		{ codigo: "66", descricao: "CRIZAL SAPPHIRE" },
		{ codigo: "67", descricao: "AR MC3" },
		{ codigo: "69", descricao: "AR MC7 BLUECUT" },
		{ codigo: "70", descricao: "AR MC5" },
		{ codigo: "71", descricao: "CRIZAL EASY PRO UV" },
		{ codigo: "99", descricao: "OUTROS AR" },
		{ codigo: "83", descricao: "CRIZAL SAPPHIRE HR" },
		{ codigo: "85", descricao: "CRIZAL SAPPHIRE HR FACE INTERNA" },
		{ codigo: "84", descricao: "CRIZAL ROCK" }
	],
	tabelaColoracao: [
		{ codigo: "00", descricao: "TINTING NOT APPLIED" },
		{ codigo: "01", descricao: "TINTING" },
		{ codigo: "33", descricao: "COLORACAO ESPECIAL" },
		{ codigo: "99", descricao: "COLORACAO" }
	],
	tabelaCorColoracao: [
		{ codigo: "CINZA1TOTAL" },
		{ codigo: "CINZA2TOTAL" },
		{ codigo: "CINZA3TOTAL" },
		{ codigo: "CINZADEGRADE" },
		{ codigo: "CONFORMEAMOSTRA" },
		{ codigo: "MARROM1TOTAL" },
		{ codigo: "MARROM2TOTAL" },
		{ codigo: "MARROM3TOTAL" },
		{ codigo: "MARROMDEGRADE" },
		{ codigo: "VERDE1TOTAL" },
		{ codigo: "VERDE2TOTAL" },
		{ codigo: "G15TOTAL" },
		{ codigo: "G15DEGRADE" }
	],
	tabelaHC: [
		{ codigo: "00", descricao: "HC NOT APPLIED" },
		{ codigo: "01", descricao: "HC DIP" },
		{ codigo: "02", descricao: "HC SPIN" },
		{ codigo: "04", descricao: "HC BST" },
		{ codigo: "99", descricao: "HC OUTROS" }
	],
	tabelaCorte: [
		{ codigo: "00", descricao: "SEM CORTE" },
		{ codigo: "01", descricao: "COM CORTE" },
		{ codigo: "02", descricao: "MONTAGEM ACETATO" },
		{ codigo: "03", descricao: "MONTAGEM FIO DE ACO" },
		{ codigo: "04", descricao: "MONTAGEM FIO DE ACO FLEX" },
		{ codigo: "05", descricao: "MONTAGEM METAL/ZYLO" },
		{ codigo: "06", descricao: "MONTAGEM NYLON" },
		{ codigo: "07", descricao: "MONTAGEM TRES PECAS" }
	],
	tabelaTipoArmacao: [
		{ codigo: "METAL EDGE", descricao: "METAL / ZYL" },
		{ codigo: "RIMLESS EDGE", descricao: "TRES PECAS PASSANTE" },
		{ codigo: "ZYL EDGE", descricao: "ACETATO" },
		{ codigo: "GROOVE EDGE", descricao: "NYLON" },
		{ codigo: "FIO DE ACO", descricao: "FIO DE ACO" },
		{ codigo: "FIO DE ACO FLEX", descricao: "FIO DE ACO FLEX" },
		{ codigo: "RIMLESS TAM", descricao: "TRES PECAS TAMBOR" },
		{ codigo: "RIMLESS EXT", descricao: "TRES PECAS EXTENSOR" }
	]
};
